import type { DocumentPreviewHeader } from 'types/contextDocuments';

export interface HeaderTreeNode extends DocumentPreviewHeader {
  children: HeaderTreeNode[];
}

/**
 * Строит дерево заголовков из плоского списка превью.
 * parent_id === null → корень; корней может быть несколько.
 * Узел с несуществующим parent_id не теряем — поднимаем в корни.
 */
export function buildHeaderTree(flat: DocumentPreviewHeader[]): HeaderTreeNode[] {
  const nodes = new Map<string, HeaderTreeNode>();
  // Два прохода: сначала наполняем Map всеми узлами — при одном проходе
  // parent_id может ссылаться на узел, идущий позже в плоском списке.
  flat.forEach((header) => nodes.set(header.id, { ...header, children: [] }));

  const roots: HeaderTreeNode[] = [];
  flat.forEach((header) => {
    const node = nodes.get(header.id);
    if (!node) return;
    const parent = header.parent_id ? nodes.get(header.parent_id) : undefined;
    if (parent) parent.children.push(node);
    else roots.push(node);
  });
  return roots;
}

/** id всех потомков узла (сам узел не входит). */
export function getDescendantIds(node: HeaderTreeNode): string[] {
  return node.children.flatMap((child) => [child.id, ...getDescendantIds(child)]);
}
